/**
 * The shared state of the cosmic backdrop. Pages tell it what the ritual is doing and the canvas
 * (CosmicCanvas) reads it every frame, so there is one animation loop for the whole app.
 */
export type CosmosMode = 'idle' | 'charge';

interface CosmosState {
    mode: CosmosMode;
    modeSince: number;
    burstAt: number;
}

const now = () => performance.now();

export const cosmosState: CosmosState = {
    mode: 'idle',
    modeSince: now(),
    burstAt: -1e9,
};

export const cosmos = {
    /** The stars drift (idle) or spiral inward faster and faster (charge). */
    setMode(mode: CosmosMode) {
        if (cosmosState.mode === mode) return;
        cosmosState.mode = mode;
        cosmosState.modeSince = now();
    },
    /** A shockwave, a flash and a shower of sparks. Also returns the stars to idle. */
    burst() {
        cosmosState.burstAt = now();
        cosmos.setMode('idle');
    },
};

/** 0 to 1 over `seconds` of charging; 0 when not charging. */
export const chargeLevel = (seconds = 3.2): number =>
    cosmosState.mode === 'charge'
        ? Math.min(1, (now() - cosmosState.modeSince) / 1000 / seconds)
        : 0;
